function init(elementId) {

    $(`#${elementId}`).not('.slick-initialized').slick({
        dots: false,
        infinite: false,
        speed: 800,
        slidesToShow: 2,
        slidesToScroll: 2,
        rows: 0,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });

}

export default {
    init
}